import React from 'react';
import { Link, useParams } from 'react-router-dom';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';

import * as SystemModule from 'modules/system';
import * as CategoryModule from 'modules/category';
import * as DocumentModule from 'modules/document';

import * as Card from 'components/Card';
import Spinner from 'components/Spinner';
import Modal from 'components/Modal';

import classes from '../LandingPage.module.scss';

const CategoryList: React.FC = () => {
  const { t } = useTranslation();
  const { language } = SystemModule.Hooks.useLanguage();
  const { serviceId } = useParams<{ serviceId: string }>();
  const { state, methods } = CategoryModule.Context.Single.useContext();
  const { items, isFetched, isLoaded } = CategoryModule.Hooks.useList();
  DocumentModule.Hooks.useList();

  if (!isLoaded) {
    return null;
  }

  return (
    <>
      <div className={classes.section}>
        <div className={classes.sectionHeader}>
          <div className={classes.sectionTitle}>{t('Types_licenses_permits')}</div>
          {window.matchMedia('(min-width: 992px)').matches && (
            <Link className={classes.sectionLink} to="/services">
              {t('All_licenses_permits')}
            </Link>
          )}
        </div>
        <div className={classes.sectionContent}>
          <div className={classes.categoryListWrapper}>
            <div className={classes.categoryListWrapperInner}>
              {items.map(item => (
                <div key={item.id} className={classes.categoryListItem}>
                  <Card.Info
                    className={classes.listItemCard}
                    title={get(item, `title[${language}]`)}
                    description={get(item, `description[${language}]`)}
                    subCategories={item.children.map(category => ({
                      key: category.id,
                      onClick: () => {
                        !item.soon && methods.setSubCategory(category.id, item.id);
                      },
                      title: get(category, `title[${language}]`)
                    }))}
                    image={item.image}
                    gradient={item.gradient}
                    soon={item.soon}
                    onClick={() => !item.soon && methods.setCategory(item.id)}
                  />
                </div>
              ))}
            </div>
            {!isFetched && !isLoaded && (
              <div className={classes.spinner}>
                <Spinner size={32} />
              </div>
            )}
          </div>
        </div>
      </div>
      {!window.matchMedia('(min-width: 992px)').matches && (
        <div className={classes.sectionHeader}>
          <Link className={classes.sectionLink} to="/services">
            {t('All_licenses_permits')}
          </Link>
        </div>
      )}
      {serviceId && Number(serviceId) && <CategoryModule.Containers.DocumentView serviceId={Number(serviceId)} />}
      <Modal size="middle" isOpen={state.isVisible} close={methods.setClose}>
        <CategoryModule.Containers.View />
      </Modal>
    </>
  );
};

export default CategoryList;
